<script setup lang="ts">
import { ref } from 'vue';
import { DsBreadcrumb } from '@coloplast/design-system';

interface BreadcrumbItem {
	Name: string;
	Active: boolean;
	Link: string;
}

interface GlobalBreadcrumbProps {
	vm: {
		BaseViewModel: {
			HideBreadcrumb?: boolean;
			ShowBreadcrumbBackground?: boolean;
			BreadcrumbItems: BreadcrumbItem[];
			BreadcrumbMenuLabel?: string;
			BreadcrumbShowMoreLabel?: string;
		}
	}
}

const props = defineProps<GlobalBreadcrumbProps>();

const breadcrumbItems = ref(
	props.vm.BaseViewModel.BreadcrumbItems.map((breadcrumbItem) => {
		return {
			name: breadcrumbItem.Name,
			url: breadcrumbItem.Link,
			isCurrentPage: breadcrumbItem.Active,
		};
	}),
);
</script>

<template>
	<DsBreadcrumb
		:ariaLabel="props.vm.BaseViewModel.BreadcrumbMenuLabel ?? 'Breadcrumb'"
		:overflowMenuTooltipText="props.vm.BaseViewModel.BreadcrumbShowMoreLabel ?? 'More items'"
		:items="breadcrumbItems"
	/>
</template>
